const default_state = {
    tab_index: 0,
    map: {
        popup: {
            open: false,
            position: [0, 0],
            content: '',
        },
    },
};
export const reducer = (state = default_state, action) => {
    switch (action.type) {
        case 'BAXI_SERVICE_SET_TAB_INDEX':
            return { ...state, tab_index: action.index };
        case 'BAXI_SERVICE_MAP_TOGGLE_POPUP':
            return {
                ...state,
                map: {
                    ...state.map,
                    popup: {
                        ...state.map.popup,
                        open: action.state,
                    },
                },
            };
        case 'BAXI_SERVICE_MAP_SET_POPUP_POSITION':
            return {
                ...state,
                map: {
                    ...state.map,
                    popup: {
                        ...state.map.popup,
                        position: action.position,
                    },
                },
            };
        case 'BAXI_SERVICE_MAP_SET_POPUP_CONTENT':
            return {
                ...state,
                map: {
                    ...state.map,
                    popup: {
                        ...state.map.popup,
                        content: action.content,
                    },
                },
            };
        default:
            return state;
    }
};
